module.exports = __webpack_public_path__ + "img/wallets.2affd490.svg";